// Disable no-re-export rule for entry point files
/* eslint-disable @atlaskit/editor/no-re-export */
import { NextEditorPluginAI } from './aiPlugin';

const aiPlugin = NextEditorPluginAI;
export { aiPlugin };

export type { AIPlugin, AIPluginOptions } from './aiPluginType';
export type { EditorPluginAIProvider, EditorPluginAISharedState } from './types/types';
export type { EditorPluginAIActions } from './editor-actions/types';
